import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class VoucherService {
  private voucherUrl = `${environment.baseUrl}fa/Voucher`;
  private voucherDetailUrl = `${environment.baseUrl}fa/VoucherDetail`;

  constructor(private http: HttpClient) { }

  getVouchers(storeCode: string): Observable<any[]> {
    return this.http.get<any[]>(`${this.voucherUrl}?storecode=${storeCode}`);
  }

  getVoucherDetails(voucherId: number): Observable<any> {
    return this.http.get<any>(`${this.voucherUrl}/${voucherId}`);
  }

  addVoucher(payload: any): Observable<any> {
    return this.http.post<any>(this.voucherUrl, payload);
  }

  updateVoucher(payload: any): Observable<any> {
    return this.http.put<any>(`${this.voucherUrl}/${payload.Voucher.VoucherId}`, payload);
  }

  deleteVoucher(voucherId: number): Observable<any> {
    return this.http.delete<any>(`${this.voucherUrl}/${voucherId}`);
  }

  addVoucherDetail(payload: any): Observable<any> {
    return this.http.post<any>(this.voucherDetailUrl, payload);
  }

  updateVoucherDetail(payload: any): Observable<any> {
    return this.http.put<any>(this.voucherDetailUrl, payload);
  }

  deleteVoucherDetail(voucherId: number, rowId: number): Observable<any> {
    return this.http.delete<any>(`${this.voucherDetailUrl}/${voucherId}/${rowId}`);
  }
}
